// extracted by mini-css-extract-plugin
module.exports = {"row":"Styles_row__pMTXa","row__label":"Styles_row__label__vJU5V","select":"Styles_select__gocbs"};